export const NON_GRAY_TONES = [
    'blue',
    'green',
    'yellow',
    'red',
    'purple',
    'aqua',
    'orange',
] as const;

export type TagTone = (typeof NON_GRAY_TONES)[number];
